// Day-level date/time helpers (spec 0.5: never show hours/minutes/seconds)
export function formatDay(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const day = String(d.getDate()).padStart(2, "0");
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];
  return `${day} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

export function daysBetween(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const diff = Date.now() - then;
  return Math.max(0, Math.floor(diff / (1000 * 60 * 60 * 24)));
}

export function daysInStageLabel(iso) {
  const d = daysBetween(iso);
  if (d === null) return "—";
  return `${d} ${d === 1 ? "day" : "days"} in stage`;
}

// Verdict display labels (spec 0.10)
export const VERDICT_LABEL = {
  go: "PROCEED",
  watch: "NEEDS REVIEW",
  no_go: "REJECT",
};
export const VERDICT_COLOR = {
  go: "#2C9A52",
  watch: "#E0A100",
  no_go: "#D64545",
};
